import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  TableHead,
} from "@material-ui/core";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
// styles
import useStyles from "../../../themes/makeStyles";
import clsx from "clsx";
import moment from "moment";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import PropTypes from "prop-types";
import { default as Apiservices } from "../../../common";
import {
  useForm,
  Controller,
  FormContext,
  useFormContext,
  useFieldArray,
} from "react-hook-form";
import DateRangePicker from "../../../components/DateRangePicker";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(0),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
  table: {
    minWidth: "100%",
    whiteSpace: "nowrap",
    td: {},
  },
  toobarBgColor: {
    "& .MuiToolbar-regular": {
      background: "#fff",
    },
  },
  container: {
    maxHeight: "60vh",
    minHeight: "100px",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },

      /* Track */

      "&::-webkit-scrollbar-track": {
        background: "#fff",
      },

      /* Handle */

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#d4d8da",
        borderRadius: "20px",
      },

      /* Handle on hover */

      "&::-webkit-scrollbar-thumb:hover": {
        background: "",
      },
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function RakeDetentionReport(props) {
  var classesTwo = useStyles();
  const classes = useStyles2();
  const [resetvalues, setResetvalues] = React.useState(true);
  const [consolidatedReportData, setConsolidatedReportData] = React.useState(
    []
  );
  const [page, setPage] = React.useState(0);
  const [array, setArray] = React.useState([
    { invoicedate: "No Data", count: "No Data" },
  ]);
  const [loading, setLoading] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [endDate, setEndDate] = React.useState(null);
  const [disableSftoButton, setDisableSftoButton] = useState(true);
  const [sftorrStartDate, setSftorrStartDate] = useState();
  const [sftorrEndDate, setSftorrEndDate] = useState();

  const methods = useForm({
    mode: "onChange",
    validateCriteriaMode: "all",
    // defaultValues: getHeaderInfoDefaultData(modeOfDispatch),
  });

  const {
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    reset,
    getValues,
  } = methods;

  var tableData = [
    {
      actual_arrival_at_destination_date_time: "No Data",
      arrival_at_plant_date_time: "No Data",
      arrival_tt_btw_tatanagr_tsl: "No Data",
      arrival_tt_btw_tsl_tws: "No Data",
      arrival_tt_btw_tws_placement: "No Data",
      destination: "No Data",
      draw_out_date_time: "No Data",
      loading_end_time: "No Data",
      loading_start_time: "No Data",
      loadno: "No Data",
      loco_allotment_datetime: "No Data",
      months: "No Data",
      offered_to_customer_by_tmill_or_railways: "No Data",
      offered_to_railways_date_time: "No Data",
      origin: "No Data",
      origin_code: "No Data",
      railways_insp_strt_time: "No Data",
      rake_arrival_at_yard_date_time: "No Data",
      rake_departure_datetime: "No Data",
      rake_placement_date_time: "No Data",
      raketype: "No Data",
      return_arrival_date_time: "No Data",
      return_departure_date_time: "No Data",
      return_drawout_date_time: "No Data",
      total_tt_tsl_plant: "No Data",
      total_turnaround: "No Data",
      tt_btw_departure_from_origin_to_arrival: "No Data",
      tt_btw_drawout_departure: "No Data",
      tt_btw_drawout_trainordering: "No Data",
      tt_btw_loadindcompletion_railway: "No Data",
      tt_btw_placement_loadindcompletion: "No Data",
      tt_btw_railway_tatanagar: "No Data",
      tt_btw_tatanagar_destination: "No Data",
      tt_btw_trainordering_tatanagar: "No Data",
      tt_btw_unloading_at_destination: "No Data",
      tt_btw_unloading_comp_drawout_from_destination: "No Data",
      unloading_end_date_time: "No Data",
    },
  ];

  const fetchData = async () => {
    let queryparams = {
      rr_start_date: "1970-01-01",
      rr_end_date: "2050-01-01",
    };
    const response = await Apiservices.rakeDetentionReports(queryparams);
    if (response) {
      setArray(
        response.Records && response.Records.length > 0
          ? response.Records[0]
          : tableData
      );
      // console.log("getting data", response[0][0].rake_arrival_date)
    } else {
      setArray(tableData);
      console.log("Server not working");
    }
  };

  const handleSearchCriteriaSubmit = async (submitteddata) => {
    let queryparams = {};
    let rr_start_end_dates = submitteddata.rr_start_end_date
      ? submitteddata.rr_start_end_date.split("To")
      : null;
    queryparams.rr_start_date = rr_start_end_dates
      ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
      : null;
    queryparams.rr_end_date = rr_start_end_dates
      ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
      : null;
    setLoading(true);
    let response = await Apiservices.rakeDetentionReports(queryparams);
    if (response && response.Records.length > 0) {
      setArray(
        response.Records && response.Records.length > 0
          ? response.Records[0]
          : tableData
      );
      setDisableSftoButton(false);
    } else {
      setArray(tableData);
      console.log("Server not working");
    }
    setLoading(false);
  };

  const resetForm = async () => {
    setResetvalues(!resetvalues);
    setDisableSftoButton(true);
    let obj = {
      rr_start_date: "2009-01-01",
      rr_end_date: "2070-01-01",
    };
    setLoading(true);
    let response = await Apiservices.rakeDetentionReports(obj);
    setArray(
      response.Records && response.Records.length > 0
        ? response.Records[0]
        : tableData
    );
    setLoading(false);
  };

  const generateReport = async () => {
    let startDate = null,
      endDate = null;
    if (sftorrStartDate) {
      startDate = sftorrStartDate;
    } else {
      startDate = "2012-01-01";
    }
    if (sftorrEndDate) {
      endDate = sftorrEndDate;
    } else {
      endDate = new Date(moment(new Date()).format("YYYY-MM-DD"));
    }
    let data = {
      rr_start_date: startDate,
      rr_end_date: endDate,
    };
    Apiservices.downloadDetentionDashboardReports(data);
  };

  useEffect(() => {
    const response = fetchData();
    // const fetchData = async () => {
    //     let submitResults = await consolidated_reports({
    //         start_date: null,
    //         end_date: null
    //     });
    //     console.log('reports data comes here', submitResults);
    //     setConsolidatedReportData(submitResults);
    //     if (submitResults && submitResults.records) {
    //         setArray(submitResults.records);
    //     } else {
    // setArray(tableData);
    //     }
    // }
    // fetchData();
  }, []);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, array.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const generateReport = async (details) => {
  //     console.log(details);
  //     let dates = {
  //         start_date: startDate,
  //         end_date: endDate
  //     }
  //     let filename =
  //         "consolidated_reports_" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  //     let submitResults = await download_consolidated_reports(filename, dates);
  //     console.log(submitResults);
  // Apiservices.downloadDashboardJobDetails(startDate, endDate);
  // }

  const getSplInstructions = (instructions) => {
    const spitOfInstructions = instructions.split(" ");
    const loadIndex = spitOfInstructions.findIndex((instruction) =>
      ["load", "LOAD", "Load"].includes(instruction)
    );
    return spitOfInstructions.slice(0, loadIndex + 1).join(" ");
  };

  // const getSplInstructions = (instructions) => {
  //     let value = '';
  //     let spitOfInstructions = instructions.split(" ");
  //     for (let i = 0; spitOfInstructions.length; i++) {
  //         if (spitOfInstructions[i] === 'Load' || spitOfInstructions[i] === 'LOAD' || spitOfInstructions[i] === 'load') {
  //             value = value + ' ' + spitOfInstructions[i];
  //             return value;
  //         } else {
  //             value = value + ' ' + spitOfInstructions[i];
  //         }
  //     }
  //     return value;
  // }

  // const getSplInstructions = (instructions) => {
  //     const spitOfInstructions = instructions.split(" ");
  //     const result = spitOfInstructions.filter(instruction => /load/i.test(instruction));
  //     return result.join(" ");
  // }

  const sendMail = async () => {
    console.log("test sending mail");
    Apiservices.testSendingMail();
  };

  return (
    <>
      {/* <div> */}
      <Box py={3}>
        <Grid container spacing={2} justify="space-between" alignItems="center">
          <Grid item>
            <h2 className={classesTwo.mainHeading}>
              {"SFTO - Rake Detention Report"}
            </h2>
          </Grid>
        </Grid>
      </Box>

      <Box py={1}>
        <form
          onSubmit={handleSubmit(handleSearchCriteriaSubmit)}
          id="list-job"
          key={resetvalues}
        >
          <Grid
            container
            spacing={2}
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <Controller
                as={<DateRangePicker />}
                name="rr_start_end_date"
                control={control}
                rules={{ required: false }}
                required={false}
                disabled={false}
                onChange={([value]) => {
                  let queryparams = {};
                  let rr_start_end_dates = value.split("To");
                  setSftorrStartDate(
                    rr_start_end_dates
                      ? moment(
                          rr_start_end_dates[0].trim(),
                          "DD-MM-YYYY"
                        ).format("YYYY-MM-DD")
                      : null
                  );
                  setSftorrEndDate(
                    rr_start_end_dates
                      ? moment(
                          rr_start_end_dates[1].trim(),
                          "DD-MM-YYYY"
                        ).format("YYYY-MM-DD")
                      : null
                  );
                  return value;
                }}
                id="rr_start_end_date"
                label="RR Date Range"
              />
            </Grid>
            <Grid item>
              <Grid container spacing={2} justify="flex-end">
                {/* <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={clsx(
                                            classes.subTextButton
                                        )}
                                        type="button"
                                        onClick={sendMail}
                                    >
                                        Send Mail
                                    </Button>
                                </Grid> */}

                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    className={clsx(classes.subTextButton)}
                    type="submit"
                  >
                    Search
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    variant="outlined"
                    className={clsx(classes.subTextButton)}
                    onClick={resetForm}
                  >
                    Clear
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    className={clsx(classes.subTextButton)}
                    type="button"
                    onClick={generateReport}
                    startIcon={<CloudDownloadIcon />}
                    disabled={disableSftoButton}
                  >
                    Export to Excel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>

      <>
        <Box py={1}>
          <TableContainer
            component={Paper}
            className={clsx("freezeTable", classes.container)}
          >
            <Table
              // className={classes.table}
              aria-label="simple table"
              stickyHeader
            >
              {loading ? (
                <></>
              ) : (
                <>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center">
                        <b>JOB ID</b>
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ minWidth: 100 }}>
                        <b>MONTH</b>
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ minWidth: 120 }}>
                        <b>LOAD NO</b>
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ minWidth: 60 }}>
                        <b>RAKE ID/TYPE</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>ORIGIN</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>DESTINATION</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>ARRIVAL AT ORIGIN RY</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>TXR Date</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>OFFERED TO TSL</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>ARRIVAL AT RY TO OFFER</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>ARRIVAL AT PLANT</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>ARRIVAL AT RY TO PLANT</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>PLACEMENT FOR LOADING</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>ARRIVAL AT PLANT TO PLACEMENT</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>LOADING COMPLETED</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>PLACEMENT TO LOADING</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>OFFER TO RAILWAYS</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>LOADING COMP TO OFFERED TO RLY</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>DRAW OUT TIME</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>OFFER TO RLY TO DRAWN OUT</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>TOTAL TIME TAKEN INSIDE TSL PLANT</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>TRAIN ORDERED</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>DRAWN OUT TO TRAIN ORDER </b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>DEPARTURE FROM ORIGIN RY</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>TRAIN ORDERED TO DEPARTURE</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>ARRIVAL AT DESTINATION</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>LOADED TRANSIT TIME</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>PLACEMENT AT DESTINATION</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>UNLOADING COMPLETED</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>PLACEMENT TO UNLOADING AT DESTINATION</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>DRAW OUT FROM DESTINATION YARD</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>UNLOADING COMPLETION TO DRAWN OUT TIME</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>DEPARTURE FROM DESTINATION</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>DRAW OUT TO DEPARTURE</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>EMPTY RETURN TO</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>EMPTY RETURN </b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>EMPTY TRANSIT TIME</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>TAT (OFFER TO OFFER)</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>TAT (ARRIVAL TO ARRIVAL)</b>
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? array.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : array
                    ).map((row, index) => (
                      <TableRow key={index}>
                        <TableCell
                          align="center"
                          style={{ minWidth: 190, maxWidth: 190 }}
                        >
                          <div>
                            {row.job_id ? <b>{row.job_id}</b> : <b>-</b>}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.months ? (
                              <b>{`${new Date(row.months).toLocaleString(
                                "default",
                                { month: "long" }
                              )}, ${moment(row.months).format("YYYY")}`}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.special_instructions ? (
                              <b>
                                {getSplInstructions(row.special_instructions)}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.rake_id ? <b>{row.rake_id}</b> : <b>-</b>}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.origin ? <b>{row.origin}</b> : <b>-</b>}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.destination ? (
                              <b>{row.destination}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.arrival_at_tatanagar_rail ? (
                              <b>
                                {moment(row.arrival_at_tatanagar_rail).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.txr_date ? (
                              <b>
                                {moment(row.txr_date).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.offered_to_tsl ? (
                              <b>
                                {moment(row.offered_to_tsl).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_tatanagar_to_tsl ? (
                              <b>{row.tt_btw_tatanagar_to_tsl}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.arrival_at_tws ? (
                              <b>
                                {moment(row.arrival_at_tws).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_offered_to_tsl_and_arrival_at_tws ? (
                              <b>
                                {row.tt_btw_offered_to_tsl_and_arrival_at_tws}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.placement_for_loading ? (
                              <b>
                                {moment(row.placement_for_loading).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_arrival_in_tws_and_placement ? (
                              <b>{row.tt_btw_arrival_in_tws_and_placement}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        {/* complete the following */}
                        <TableCell align="center">
                          <div>
                            {row.loading_completed ? (
                              <b>
                                {moment(row.loading_completed).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_placement_and_completion ? (
                              <b>{row.tt_btw_placement_and_completion}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.offered_to_railways ? (
                              <b>
                                {moment(row.offered_to_railways).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_loading_complete_and_offered ? (
                              <b>{row.tt_btw_loading_complete_and_offered}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.draw_out_from_tws_to_tatanagar ? (
                              <b>
                                {moment(
                                  row.draw_out_from_tws_to_tatanagar
                                ).format("DD-MM-YYYY, HH:mm")}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_offered_to_drawout_tatanagar ? (
                              <b>{row.tt_btw_offered_to_drawout_tatanagar}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.total_tt_inside_tsl ? (
                              <b>{row.total_tt_inside_tsl}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.train_ordered ? (
                              <b>
                                {moment(row.train_ordered).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_drawout_and_train_order ? (
                              <b>{row.tt_btw_drawout_and_train_order}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.departure_from_tatanagar ? (
                              <b>
                                {moment(row.departure_from_tatanagar).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_train_ordering_and_departure ? (
                              <b>{row.tt_btw_train_ordering_and_departure}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.arrival_at_destination ? (
                              <b>
                                {moment(row.arrival_at_destination).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_tatanagar_departure_and_arrival_at_destination ? (
                              <b>
                                {
                                  row.tt_btw_tatanagar_departure_and_arrival_at_destination
                                }
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.placement_at_destination ? (
                              <b>
                                {moment(row.placement_at_destination).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.unloading_completed_at_dest ? (
                              <b>
                                {moment(row.unloading_completed_at_dest).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_placement_and_unloading ? (
                              <b>{row.tt_btw_placement_and_unloading}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.draw_out_from_destinations ? (
                              <b>
                                {moment(row.draw_out_from_destinations).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_unloading_completed_drawn_out ? (
                              <b>{row.tt_btw_unloading_completed_drawn_out}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.departure_from_dest ? (
                              <b>
                                {moment(row.departure_from_dest).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_draw_out_departure ? (
                              <b>{row.tt_btw_draw_out_departure}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.empty_return_to_tws ? (
                              <b>{row.empty_return_to_tws}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.arrival_tatanagar_rly ? (
                              <b>
                                {moment(row.arrival_tatanagar_rly).format(
                                  "DD-MM-YYYY, HH:mm"
                                )}
                              </b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tt_btw_rake_dep_from_origin ? (
                              <b>{row.tt_btw_rake_dep_from_origin}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.total_turnarround ? (
                              <b>{row.total_turnarround}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div>
                            {row.tat_arrival_to_arrival ? (
                              <b>{row.tat_arrival_to_arrival}</b>
                            ) : (
                              <b>-</b>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>

                  <TableFooter>
                    <TableRow></TableRow>
                  </TableFooter>
                </>
              )}
            </Table>
          </TableContainer>
          <TableContainer>
            <TablePagination
              className={classes.toobarBgColor}
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              component="div"
              count={array.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableContainer>
        </Box>
      </>
      {/* </div> */}
    </>
  );
}
